import { getBookedSubTypeFilter } from './DefaultFilters';
import { SmartSendFilterContext, checkLists } from './SmartSendFilterApplier';

export function DefaultSubTypeFilter(subType: string, take?: number, skip?: number): SmartSendFilterContext {
  return {
    AvailableFilters: [
      {
        name: 'SubType',
        hidden: true,
        options: [],
        style: 'CHECKBOX',
        valid: (i, f, s) => checkLists(s, i.SubType)
      }
    ],
    CurrentFilter: getBookedSubTypeFilter(subType, take ?? 5, skip ?? 0)
  };
}
